import type { ConfigModel } from '@gwm/bridge'

enum BrandEnum {
  ORA = 3,
  PICKUP = 5,
  HAVAL = 1,
  WEY = 2,
  TANK = 7,
  SOUL = 9,
  GWM = 10,
}

const BrandAll = [
  BrandEnum.ORA,
  BrandEnum.HAVAL,
  BrandEnum.PICKUP,
  BrandEnum.SOUL,
  BrandEnum.TANK,
  BrandEnum.WEY,
  BrandEnum.GWM,
]

const config: ConfigModel = {
  pushViewGwm: {
    name: 'Controller.pushViewController',
    desc: '打开H5页面，超级APPH5专用',
    brand: BrandAll,
    deal: (data: { page: string; hiddenNav: boolean }) => {
      if (!/^https?:/.test(data.page)) {
        const prefixUrl = import.meta.env.VITE_NODE_ENV === 'local' ? '#' : '/sapp-h5/index.html#'
        data.page = `${window.location.origin}${prefixUrl}${data.page}`
      }
      return data
    },
  },
  pushNativeGwm: {
    name: 'Controller.pushNativeController',
    desc: '打开原生或H5页面',
    brand: BrandAll,
    deal: (data: { url: string }) => {
      if (/^sapp:/.test(data.url)) {
        return data
      }
      if (!/^https?:/.test(data.url)) {
        const prefixUrl = import.meta.env.VITE_NODE_ENV === 'local' ? '#' : '/sapp-h5/index.html#'
        data.url = `${window.location.origin}${prefixUrl}${data.url}`
      }
      return data
    },
  },
  logoutApp: {
    //账户注销成功调用
    name: 'Storage.logoutApp',
    desc: '通知app退出登陆',
    brand: BrandAll,
  },
  sendCommentSuccess: {
    //帖子详情评论
    name: 'Controller.sendComment',
    desc: '帖子详情评论',
    async: true,
    brand: BrandAll,
  },
  presentSharePost: {
    //帖子详情评论分享弹窗
    name: 'Controller.presentSharePost',
    desc: '帖子详情评论',
    async: true,
    brand: BrandAll,
  },
  getCdpData: {
    // 获取cda车辆|线索数据
    name: 'Storage.cdpData',
    desc: '获取cdp车辆数据',
    brand: BrandAll,
  },
  shareMotoTrackImage: {
    name: 'Controller.shareMotoTrackImage',
    desc: '行程报告截图分享',
    async: true,
    brand: BrandAll,
  },
  requestData: {
    name: 'Controller.requestData',
    desc: 'App代理请求Ntsp和Gtsp接口',
    async: true,
    brand: BrandAll,
  },
}

export default config
